import * as React from 'react';
import { default as NearMeIcon } from '@material-ui/icons/NearMe';
import { default as GpsFixedIcon } from '@material-ui/icons/GpsFixed';
import { default as GpsNotFixedIcon } from '@material-ui/icons/GpsNotFixed';
import { default as GpsOffIcon } from '@material-ui/icons/GpsOff';
import IconButton from '@material-ui/core/IconButton';
import MapButton from './MapButton';
import { observer } from 'mobx-react-lite';
import { PositionWatcherError } from '../gps/PositionWatcher';
const OwnLocationButton = observer((props) => {
    const { positionWatcher, positionLock, className, setPositionLock } = props;
    let state = 'gpsNotFixed';
    const pw = positionWatcher;
    if (pw.position) {
        state = 'gpsFixed';
    }
    else if (pw.error) {
        const errCode = pw.error.code;
        if (errCode === PositionWatcherError.POSITION_UNAVAILABLE ||
            errCode === PositionWatcherError.TIMEOUT ||
            errCode === PositionWatcherError.PERMISSION_DENIED) {
            state = 'gpsOff';
        }
    }
    const onClick = () => {
        positionWatcher.watchPosition();
        setPositionLock(true);
    };
    if (positionLock && state === 'gpsFixed')
        state = 'positionLock';
    return (React.createElement(MapButton, { className: className },
        React.createElement(IconButton, { onClick: onClick },
            state === 'gpsFixed' && React.createElement(GpsFixedIcon, null),
            state === 'gpsNotFixed' && React.createElement(GpsNotFixedIcon, null),
            state === 'gpsOff' && React.createElement(GpsOffIcon, null),
            state === 'positionLock' && React.createElement(NearMeIcon, null))));
});
export default OwnLocationButton;
